import { html } from "lit";
import {
    dummyProducts,
    TeaserProductTileTemplate,
} from "../../../partial-templates/teaser/product/teaser-product.templates";
import { ViewAllBlockTemplate } from "./view-all.templates";

export const ProductSliderTemplate = ({ tab = "products" }) => {
    return html`
        <ux-slider
            breakpoint-s="767"
            breakpoint-m="1023"
            breakpoint-l="1440"
            visible-slides-s="1"
            visible-slides-m="2"
            visible-slides-l="3"
            visible-slides-xl="4"
            space-between-s="10"
            space-between-m="30"
            space-between-l="30"
            space-between-xl="30"
            slides-per-group-l="3"
            slides-per-group-xl="3"
            arrows-follow-img="ux-iws-teaser-product-tile"
            container-classes="ux-col-12 ux-col-sm-10 ux-u-offset-sm-1 ux-u-margin-bottom-5 ux-u-margin-m-bottom-25"
            faded-sides
            slides-auto-height
        >
            ${dummyProducts.map((teaser, index) => {
                if (index > 4) return;
                return html`<ux-slider-slide class="ux-u-margin-top-25">
                    ${TeaserProductTileTemplate(teaser)}
                </ux-slider-slide>`;
            })}
            <ux-slider-slide class="ux-u-margin-top-25">
                ${ViewAllBlockTemplate({
                    icon: "tiles-big",
                    tab: tab,
                    text: "Alle Ergebnisse anzeigen",
                })}
            </ux-slider-slide>
            <ux-slider-pagination
                slot="pagination"
                bottom-pagination
            ></ux-slider-pagination>
        </ux-slider>
    `;
};
